import Typography from '@material-ui/core/Typography';
import NextLink from 'next/link';

import { Link } from './faq.styles';

export const FAQ_DATA = [
  {
    name: 'What is shared ownership?',
    description: (
      <>
        <Typography variant="body1">
          Shared ownership is a government-backed scheme, designed to make
          stepping onto the property ladder more affordable. You buy a portion
          of a home normally with a mortgage and a deposit, and pay a low-cost
          rent on the rest.
        </Typography>
        {/* <Typography variant="body1">
          Read more on the{' '}
          <NextLink href="/faq/shared-ownership" prefetch={false} passHref>
            <Link component="a">Shared Ownership FAQ</Link>
          </NextLink>
        </Typography> */}
      </>
    ),
  },
  {
    name: 'Eligibility criteria',
    description: (
      <>
        <Typography variant="body1">
          The eligibility criteria for Shared Ownership is simple; as long as
          you don’t currently own, or won’t own another property when you move
          in to a new home, you’re likely to qualify.
        </Typography>
        <br />
        <Typography variant="body1">
          Your annual household income (that’s both yours and your partners’ if
          buying together) can’t exceed £80,000 (or £90,000 in London) and
          you’ll need to have savings to cover purchasing costs such as
          solicitors fees and your mortgage deposit. There’s no fixed minimum
          income; you just need to be able to afford to buy the home and the
          monthly costs - this will be established via an affordability
          assessment.
        </Typography>
        {/* <Typography variant="body1">
          Read more about eligibility{' '}
          <NextLink href="/faq/shared-ownership" prefetch={false} passHref>
            <Link component="a">in the FAQ</Link>
          </NextLink>
        </Typography> */}
      </>
    ),
  },
  {
    name: 'Is Shared Ownership just for first time buyers?',
    description: (
      <Typography variant="body1">
        No - the scheme is designed to help people buy a suitably sized home
        that they cannot afford to buy otherwise. That typically means first
        time buyers, but if you've owned a home before and are selling, perhaps
        due to a divorce or needing to buy a bigger home, and cannot afford to
        buy, you might be eligible for Shared Ownership.
      </Typography>
    ),
  },
];
